import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router";
import { connect } from "react-redux";

import {
  checkItemLock,
  unlockAndClose,
  hydrateAndLockItem,
  resetLockState,
} from "editor/actions/locking";
import { setMessage } from "actions/message";
import { CHECK_LOCK_INTERVAL } from "config/constants/editor";
import dispatchInterval from "editor/utils/dispatchInterval";

import LockedContentPanel from "editor/components/LockedContentPanel";

class LockingContainer extends React.Component {
  constructor(props) {
    super(props);
    this.checkLock = this._checkLock.bind(this);
    this.hydrateAndLock = this._hydrateAndLock.bind(this);

    this.state = {
      redirecting: false,
      isNewStory: !props.id,
    };
  }

  componentDidMount() {
    this.checkLockInterval = dispatchInterval(this.checkLock, {
      seconds: CHECK_LOCK_INTERVAL,
      blocking: true,
    });
    window.addEventListener("beforeunload", this.props.unlockAndClose);
  }

  componentWillUnmount() {
    if (this.checkLockInterval) {
      this.checkLockInterval.cancel();
    }
    window.removeEventListener("beforeunload", this.props.unlockAndClose);

    if (this.props.status.lock && !this.props.status.lock.locked_by_me) {
      this.props.resetLockState();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (!this.props.id && nextProps.id) {
      //if you just made a new story, you should get the lock on it
      this.props.hydrateAndLockItem(nextProps.id, true);
    }
    if (this.props.status.lock && nextProps.status.lock) {
      if (
        this.props.status.lock.locked_by_me &&
        nextProps.status.lock.locked_by_me === false
      ) {
        this.props.setMessage({
          message: `${nextProps.status.lock.locked_by} kicked you out of the story.`,
          type: "info",
        });
        this.setState({ redirecting: true, isNewStory: false });
      }
    }
  }

  _checkLock() {
    if (this.props.editorForm.id) {
      return this.props.checkItemLock(this.props.editorForm.id);
    } else {
      return Promise.resolve();
    }
  }

  _hydrateAndLock() {
    this.props.hydrateAndLockItem(this.props.id || this.props.editorForm.id);
  }

  render() {
    if (this.state.redirecting) {
      return <Redirect to="/dashboard" />;
    }

    return (
      <>
        {this.props.children}
        <LockedContentPanel
          key="lockedContentPanel"
          lock={this.props.status.lock}
          form={this.props.editorForm}
          lockContent={this.hydrateAndLock}
          isNewStory={this.state.isNewStory}
        />
      </>
    );
  }
}

LockingContainer.propTypes = {
  editorForm: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  status: PropTypes.shape({
    lock: PropTypes.object,
  }),
  id: PropTypes.string,
  hydrateAndLockItem: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  editorForm: state.editor.form,
  status: state.editor.status,
});

const mapDispatchToProps = {
  checkItemLock,
  unlockAndClose,
  hydrateAndLockItem,
  setMessage,
  resetLockState,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LockingContainer);
